export interface ModalType {
    type: number;
    descripcion: string;
}

export enum TypeDialog {
    success = 1,
    warn = 2,
    confirm = 3,
    information = 4,
}

export enum ButtonsDialog {
    ok = 1,
    okcancel = 2,
    oknocancel = 3,
    cancel = 4,
// tslint:disable-next-line: eofline
}